/* Controllers */
angular.module('callX').controller('NotificationsCtrl', ['$scope', 'NotificationsService', '$state', 'toaster', function($scope, NotificationsService, $state, toaster) {

    var setCampaignURLs = function () {
        for(var i = 0; i < $scope.notifications.length; i++){
            if(($scope.notifications[i].link.indexOf("/publisher/campaign/"))>-1){
                $scope.notifications[i].link = $scope.notifications[i].link.replace('/publisher/campaign/','/app/campaigns/');
                $scope.notifications[i].link = '#'+$scope.notifications[i].link+'/view-statistics';
            }
        }
    };

    var getNotifications = function() {
        $scope.tableContentLoading = true;
        var callbacks = {
            success: function(data) {
                $scope.notifications = data.data.notifications;
                $scope.groupedNotifications = data.data.grouped_notifications;
                $scope.notificationCount = data.data.new_notifications;
                $scope.tableContentLoading = false;
                setCampaignURLs();
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        NotificationsService.getNotifications(callbacks);
    };

    getNotifications();

    $scope.respondToNotification = function(id) {
        var callbacks = {
            success: function(data) {
                toaster.pop('success', 'Success', 'Data successfully updated', 2000);
                getNotifications();
            },
            failure: function(data) {
                $scope.tableContentLoading = false;
            }
        };
        NotificationsService.updateNotification(id, {approved:true}, callbacks);
    };

    $scope.$on("refresh-notifications", function() {
        getNotifications();
    });
  }]);